import "./App.css";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Main from "./Component/Main";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaymentResult from "./Component/PaymentResult";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import PolicyPage from "./Component/PolicyPage";
import { policyDocuments } from "./policies";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaymentResult />} />
          <Route path="/paysuccess" element={<Navigate replace to="/payment?state=success" />} />
          {policyDocuments.map((policy) => (
            <Route key={policy.path} path={policy.path} element={<PolicyPage policy={policy} />} />
          ))}
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
